import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import {
  CollectDataResponse
} from '../models/collect-data-payload';
import { CollectDataService } from '../services/collect-data.service';

@Component({
  selector: 'app-record-list',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './record-list.component.html',
  styleUrl: './record-list.component.css'
})
export class RecordListComponent implements OnInit {
  private readonly collectDataService = inject(CollectDataService);

  protected readonly records = signal<CollectDataResponse[]>([]);
  protected readonly loading = signal<boolean>(true);
  protected readonly errorMessage = signal<string>('');
  protected readonly statusMessage = signal<string>('');

  ngOnInit(): void {
    this.loadRecords();
  }

  private loadRecords(): void {
    this.loading.set(true);
    this.errorMessage.set('');
    this.collectDataService.getCollectedDataHistory().subscribe({
      next: (records) => {
        this.records.set(records);
        this.statusMessage.set(
          records.length
            ? `Loaded ${records.length} record(s).`
            : 'No records are available yet.'
        );
        this.loading.set(false);
      },
      error: (error) => {
        const message =
          error?.error?.detail ||
          error?.message ||
          'Unable to load collected records. Please try again.';
        this.errorMessage.set(message);
        this.statusMessage.set('');
        this.records.set([]);
        this.loading.set(false);
      }
    });
  }
}
